
import React from 'react';

interface BasePayButtonProps {
    colorScheme?: 'light' | 'dark';
    onClick?: () => void;
    className?: string;
}

export const BasePayButton: React.FC<BasePayButtonProps> = ({
    colorScheme = 'light',
    onClick,
    className
}) => {
    const isLight = colorScheme === 'light';

    // Logos should be served from public assets or key CDN, using local reference for now matching docs
    // Ensure these images exist in public/images/base-account/
    const logoSrc = isLight
        ? '/images/base-account/BasePayBlueLogo.png'
        : '/images/base-account/BasePayWhiteLogo.png';

    return (
        <button
            type="button"
            onClick={onClick}
            className={className}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 16px',
                backgroundColor: isLight ? '#ffffff' : '#0000FF',
                border: isLight ? '1px solid #e5e7eb' : 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                minWidth: '180px',
                height: '44px',
                transition: 'opacity 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = '0.9')}
            onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
        >
            <img
                src={logoSrc}
                alt="Base Pay"
                style={{
                    height: '20px',
                    width: 'auto',
                    display: 'block' // Prevent layout shifts
                }}
            />
        </button>
    );
};
